import { en } from './en'
import { fr } from './fr'

export const causes = {
  en,
  fr
}